import { ShieldCheck, Lock } from "lucide-react";

const SecurityBadge = ({ compact = false }) => {
  if (compact) {
    return (
      <div
        data-testid="security-badge-compact"
        className="llu-trace-border inline-flex items-center gap-3 px-4 py-2"
      >
        <ShieldCheck className="h-4 w-4 text-[#D4AF37]" strokeWidth={1.6} />
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-white/80">
          <span>Bank-Grade Security</span>
          <span className="text-[#D4AF37]">·</span>
          <span>256-bit Encryption</span>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="security-badge"
      className="llu-trace-border relative flex flex-col gap-3 p-6 sm:flex-row sm:items-center sm:gap-6"
    >
      <div className="flex h-14 w-14 shrink-0 items-center justify-center border border-[#D4AF37]/50 bg-[#050A1F]">
        <ShieldCheck className="h-7 w-7 text-[#D4AF37]" strokeWidth={1.4} />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">
          <Lock className="h-3 w-3" />
          <span>Protected Submission</span>
        </div>
        <p className="mt-2 font-serif text-xl font-light text-white sm:text-2xl">
          Your data is safeguarded by <span className="text-[#D4AF37]">bank-grade security</span> and{" "}
          <span className="text-[#D4AF37]">256-bit AES encryption</span>.
        </p>
        <p className="mt-1 text-xs text-white/50">
          TLS 1.3 in transit · Encrypted at rest · SOC 2-aligned controls
        </p>
      </div>
    </div>
  );
};

export default SecurityBadge;
